(function($) {
    var __ = {
        body: $('body'),
        window: $(window),
        // Scene Controller
        controller: window._animations.base.controller,
        global: window._animations.base,
        ajax :  {},
        fetch: new ScrollMagic.Scene(),
        splitText : {},
        
        loadAnimations: function(){
            var timeline = new TimelineMax();

            
            
            if (__.global.screen === "large") {
                __.splitText.intro =  __.global.splitText($('.pg-office-banner--content-text'));

                timeline
                .add(TweenMax.from('.pg-header--logo', 0.4, __.global.animations.fade.down), '+=1')
                .add(TweenMax.from('.pg-navigation', 0.4, __.global.animations.slide.right) )
                .add(TweenMax.from('.pg-toggle--animation', 0.2, __.global.animations.fade.up), '+=0.2')
                .add(TweenMax.from('.pg-header--social', 0.4, __.global.animations.fade.left) )
                .add(TweenMax.from('.pg-office-banner--image', 0.4, __.global.animations.slide.left) )
                .add(TweenMax.from('.pg-office-banner--content', 0.4, __.global.animations.fade.up))
                .add(TweenMax.from('.pg-office-banner--headline--line', 0.2, {width: 0}))
                .add(TweenMax.from('.pg-office-banner--city', 0.2,  __.global.animations.slide.up));
                 __.global.staggerDisplay( __.splitText.intro, timeline);
                timeline.add(TweenMax.from('.pg-office-content', 0.4, __.global.animations.fade.up))
                .call(function() {
                    __.global.completeLoadInAnimation();
                    __.splitText.intro.revert();

                });
            }else{
                timeline
                .add(TweenMax.from('.pg-header--logo', 0.4, __.global.animations.fade.down), '+=1')
                .add(TweenMax.from('.pg-navigation', 0.4, __.global.animations.fade.down) )
                .add(TweenMax.from('.pg-toggle--animation', 0.2, __.global.animations.fade.down), '+=0.2')
                .add(TweenMax.from('.pg-office-banner--image__mobile', 0.4, __.global.animations.fade.right) )
                .add(TweenMax.from('.pg-office-banner--content', 0.2, __.global.animations.fade.up))
                .add(TweenMax.from('.pg-office-content', 0.2, __.global.animations.fade.up))
                .call(function() {
                    __.global.completeLoadInAnimation();
                });
            }
            timeline.play();
        },
        scrollAnimations: function(){
            __.contentAnimation();
            __.mapParallax();
        },
        contentAnimation: function(){
            var topContent = new TimelineMax();
            var image1 = new TimelineMax();
            var image2 = new TimelineMax();
            var imageContent = new TimelineMax();
            var bottom = new TimelineMax();

            if($('.pg-office-content').hasClass('pg-office-content__left')){
                topContent
                .add(TweenMax.from('.pg-office-content--top--image-container', 0.4, __.global.animations.slide.right) )
                .add(TweenMax.from('.pg-office-content--inner', 0.4, __.global.animations.fade.up) )


                .add(TweenMax.from('.pg-office-content--content-headline--line', 0.2, {width: 0}))
                .staggerFrom(__.global.prepareText( $( '.pg-office-content--content-headline--inner' ) ), 0.4, __.global.animations.slide.up, 0 )


                .staggerFrom(__.global.prepareText( $( '.pg-office-content--content-title' ) ), 0.4, __.global.animations.slide.up, 0 )
                .add(TweenMax.from('.pg-office-content--top--image-container--bar', 0.4, __.global.animations.slide.right) );


                imageContent
                .add(TweenMax.from('.pg-office-content--image-content', 0.5,  __.global.animations.fade.up) )
                .staggerFrom(__.global.prepareText( $( '.pg-office-content--image-inner' ) ), 1, __.global.animations.slide.up, 0 )
                .add(TweenMax.from('.pg-office-content--image-content--border', 0.5,  {right: '100%'}) );

                
                bottom
                .add(TweenMax.from('.pg-office-content--bottom-img', 1, __.global.animations.slide.right) )
                .add(TweenMax.from('.pg-office-content--bottom-line--inner', 1, { right: '100%' } ) )
                .staggerFrom(__.global.prepareText( $( '.pg-office-content--bottom-title' ) ), 1, __.global.animations.slide.up, 0 );
                
            }else{
                topContent
                .add(TweenMax.from('.pg-office-content--top--image-container', 0.4, __.global.animations.slide.left) )
                .add(TweenMax.from('.pg-office-content--inner', 0.4, __.global.animations.fade.up) )

                .add(TweenMax.from('.pg-office-content--content-headline--line', 0.2, {width: 0}))
                .staggerFrom(__.global.prepareText( $( '.pg-office-content--content-headline--inner' ) ), 0.4, __.global.animations.slide.up, 0 )

                .staggerFrom(__.global.prepareText( $( '.pg-office-content--content-title' ) ), 0.4, __.global.animations.slide.up, 0 )
                .add(TweenMax.from('.pg-office-content--top--image-container--bar', 0.4, __.global.animations.slide.left) );


                imageContent
                .add(TweenMax.from('.pg-office-content--image-content', 0.5,  __.global.animations.fade.up) )
                .staggerFrom(__.global.prepareText( $( '.pg-office-content--image-inner' ) ), 1, __.global.animations.slide.up, 0 )
                .add(TweenMax.from('.pg-office-content--image-content--border', 0.5,  {left: '100%'}) );



                bottom
                .add(TweenMax.from('.pg-office-content--bottom-img', 1, __.global.animations.slide.left) )
                .add(TweenMax.from('.pg-office-content--bottom-line--inner', 1, { left: '100%' } ) )
                .staggerFrom(__.global.prepareText( $( '.pg-office-content--bottom-title' ) ), 1, __.global.animations.slide.up, 0 );
            }


            new ScrollMagic.Scene({
                duration: $('.pg-office-content--top').height(),
                offset: 200,
                triggerHook: 1,
                triggerElement: '.pg-office-content--top'
            })
            .setTween( topContent )
            .addTo(__.controller);

            


            image1
            .add(TweenMax.from('.pg-office-content--image-container__left', 0.2,  __.global.animations.fade.up) )
            .add(TweenMax.fromTo('.pg-office-content--image-container__left', 1, { transform: 'translateY(500px)' , ease:Linear.easeNone}, { transform: 'translateY(-200px)', ease:Linear.easeNone } ), 0 );

            image2
            .add(TweenMax.from('.pg-office-content--image-container__right', 0.2,  __.global.animations.fade.up) , 0 )
            .add(TweenMax.fromTo('.pg-office-content--image-container__right', 1, {transform: 'translateY(-800px)', ease:Linear.easeNone}, {  transform: 'translateY(50px)', ease:Linear.easeNone } ), 0 );
            

                

            new ScrollMagic.Scene({
                duration: '100%',
                offset: -100,
                triggerHook: 1,
                triggerElement: '.pg-office-content--image-container__left'
            })
            .setTween( image1 )
            .addTo(__.controller);
            

            new ScrollMagic.Scene({
                duration: '100%',
                offset: -100,
                triggerHook: 1,
                triggerElement: '.pg-office-content--image-container__right'
            })
            .setTween( image2 )
            .addTo(__.controller);

            new ScrollMagic.Scene({
                duration: $('.pg-office-content--image-content').outerHeight(),
                offset: 150,
                triggerHook: 1,
                triggerElement: '.pg-office-content--image-content'
            })
            .setTween( imageContent )
            .addTo(__.controller);




            new ScrollMagic.Scene({
                duration: $('.pg-office-content--bottom').height(),
                offset: 100,
                triggerHook: 1,
                triggerElement: '.pg-office-content--bottom'
            })               
            .setTween( bottom )
            .addTo(__.controller);

        },
        mapParallax : function(){
            var mapTween = new TimelineMax();
            var map = $('.pg-google-map');
            map.addClass('j-scroll--enabled');
            mapTween
                .add(TweenMax.from('.pg-office-map--overlay', 0.5,  __.global.animations.slide.left) )
                .add(TweenMax.from('.pg-office-map--overlay', 0.5, {background: '#ef4035' }) )
                
                .staggerFrom(__.global.prepareText( $( '.pg-office-map--overlay-text' ) ), 1, __.global.animations.slide.up, 0 )
                .add(TweenMax.from('.pg-office-map--overlay-link', 0.5,  __.global.animations.slide.up, 0 ) )

                .call(function() {
                   // map.addClass('j-scroll--display');
                })
                ;
            new ScrollMagic.Scene({
                duration: 200,
                triggerHook: 1,
                triggerElement: '.pg-office-map'
            })
            .setTween( TweenMax.from('.pg-google-map',1,  __.global.animations.fade.up) )
            .addTo(__.controller);


            new ScrollMagic.Scene({
                duration: $('.pg-office-map--overlay-row').height(),
                triggerHook: 1,
                offset: 100,
                triggerElement: '.pg-office-map--overlay-row'
            })
            .setTween( mapTween )
            .addTo(__.controller);


            new ScrollMagic.Scene({
                offset: $('.pg-office-map--overlay-row').height(),
                duration: 0,
                triggerHook: 1,
                triggerElement: '.pg-office-map--overlay-row'
            })
            .setClassToggle(".pg-google-map", "j-scroll--display")
            .addTo(__.controller);
            
        },
        pageParallax : function(){

            new ScrollMagic.Scene({
                duration: '100%',
                triggerHook: 0,
            })
            .setTween( TweenMax.to('.pg-office-banner--image', 0.4, {transform: 'translateY(250px)'})  )
            .addTo(__.controller);
            
        },
        // Function to call to setup functionality
        setup: function() {
            window._animations.global.setup();
            __.loadAnimations();
            if (__.global.screen === "large") {

                __.scrollAnimations();
            }
        }
    };
    // Attach Toolbox to window //
    if (typeof window._animations === "undefined") {
        window._animations = {};
    }
    window._animations.office = __;
})(jQuery); // Fully reference jQuery after this point.